import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container, Typography, CircularProgress, Alert, Paper, Box, Grid, Divider
} from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { initKeycloak } from '../keycloak';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export default function StatisticMap() {
  const { id } = useParams();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      const kc = await initKeycloak();
      if (!kc.authenticated) {
        kc.login();
        return;
      }

      fetch(`${API_BASE_URL}/GetStoreStats/${id}`, {
        headers: { Authorization: `Bearer ${kc.token}` },
      })
        .then(res => {
          if (!res.ok) throw new Error('Erreur serveur');
          return res.json();
        })
        .then(data => {
          setStats(data);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setError('Erreur de chargement');
          setLoading(false);
        });
    })();
  }, [id]);

  if (loading) return <Box mt={4} textAlign="center"><CircularProgress /></Box>;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!stats) return null;

  const center = stats.around.find(s => s.storeId === id);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Statistiques pour le Store {id}</Typography>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography><strong>Note moyenne :</strong> {stats.averageRating}</Typography>
            <Typography><strong>Rang dans la zone :</strong> #{stats.rank}</Typography>
            <Typography><strong>Nombre de validations :</strong> {stats.totalValidations}</Typography>
            <Typography><strong>Validations réussies :</strong> {stats.validOk}</Typography>
            <Typography><strong>Taux de succès :</strong> {((stats.validOk / stats.totalValidations) * 100).toFixed(1)}%</Typography>
            <Typography><strong>Distance moyenne de scan :</strong> {stats.averageDistance.toFixed(1)} m</Typography>
            <Typography><strong>Tentatives frauduleuses :</strong> {stats.fraudCount}</Typography>
          </Grid>
        </Grid>
      </Paper>

      <Typography variant="h5" gutterBottom>Carte des Notes Moyennes dans la Zone</Typography>
      <MapContainer
        center={[center.lat, center.lon]}
        zoom={17}
        style={{ height: '400px', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {stats.around.map((s, i) => (
          <Marker key={i} position={[s.lat, s.lon]}>
            <Popup>
              Store {s.storeId} <br />
              Note: {s.averageRating}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Container>
  );
}
